import script from "./JulienBot.vue?vue&type=script&setup=true&lang=js"
export * from "./JulienBot.vue?vue&type=script&setup=true&lang=js"

import "./JulienBot.vue?vue&type=style&index=0&id=f9b969cc&scoped=true&lang=css"
import "./JulienBot.vue?vue&type=style&index=1&id=f9b969cc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9b969cc"]])

export default __exports__